import {
  init,
  replayIntegration,
  browserTracingIntegration
} from "@sentry/remix"
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react"
import { startTransition, StrictMode, useEffect } from "react"
import { hydrateRoot } from "react-dom/client"

init({
  dsn: (window as any).ENV?.sentryDsn,
  environment: (window as any).ENV?.sentryEnvironment,
  tracesSampleRate: parseFloat(
    (window as any).ENV?.sentryTracesSampleRate || "0.1"
  ),
  enableLogs: true,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true
    })
  ],

  replaysSessionSampleRate: parseFloat(
    (window as any).ENV?.sentryReplaysSampleRate || "0.1"
  ),
  replaysOnErrorSampleRate: 1
})

startTransition(() => {
  const app = <RemixBrowser />

  hydrateRoot(
    document,
    process.env.NODE_ENV === "production" ? app : <StrictMode>{app}</StrictMode>
  )
})
